import axios from 'axios'
import { CADASTRAR_ITINERARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarItinerario (itinerario) {
  const url = `${URL}/itinerario/cadastrar`;
  return dispatch => axios.post(url,itinerario , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ITINERARIO,
        payload: response
      })
  );
}
